import React from 'react'
import { formatMoney } from '../../scripts/utils/currency';
import { getSizedImageUrl } from '../../scripts/utils/image';
import safeJSONParse from '../../scripts/utils/safeJsonParse';
import CartRecommendedSelect from './portals/ProductRecommendations/CartRecommendedSelect';
import ProductCardBox from './svgs/ProductCardBox'
import countRoast from '../../scripts/utils/countRoast';
import getTasteStrFromTag from '../../scripts/utils/getTasteStrFromTag';
import extractProductTags from '../../scripts/utils/extractProductTags';
import RoastBeans from './RoastBeans';

interface ProductRecomendationsProps {
  product: {
    title: string,
    url: string,
    // eslint-disable-next-line camelcase
    featured_image: string,
    // eslint-disable-next-line camelcase
    price_varies: boolean,
    price: string | number,
    variants: [{
      id: number
      sku: string
      price: string | number
      compare_at_price: string | number
    }],
    id: string,
    options: [string],
    tags: string[],
    handle: string,
    compare_at_price: string | number
  };
  showSelect: boolean;
  fromText?: string;
  colourSwatches: string;
  roastText: string;
  tasteText: string;
  quickAddText: string
  quickAddPlus: string

}

const ProductCard = (props: ProductRecomendationsProps): JSX.Element => {
  const { product, showSelect, fromText, colourSwatches, roastText, tasteText, quickAddText, quickAddPlus } = props;
  const productUrl = `/products/${product['handle']}`

  let variantCompare = false
  product.variants.forEach(prodVariant => {
    if (prodVariant.price === product.price && prodVariant.compare_at_price === product.compare_at_price)
      variantCompare = true
  })
  
  const assemblePrice = (product) => {
    const {
      price_varies: priceVaries,
      price: prodPrice,
      compare_at_price: compareAtPrice
    } = product;
    const pricePrependiture = (priceVaries ? fromText + ' ' : '');
    const priceFormatted = formatMoney(prodPrice, window['theme'].moneyFormat);

    if (compareAtPrice > 0 && compareAtPrice !== prodPrice && variantCompare === true ) {
      const compareAtPriceFormatted = formatMoney(compareAtPrice, window['theme'].moneyFormat);

      return (
        <p>
          {pricePrependiture} <s>({compareAtPriceFormatted})</s> {priceFormatted}
        </p>
      );
    }
    return <p>{pricePrependiture} <span className="body-bold">{priceFormatted}</span></p>
  }

  const swatchHandler = (): Record<string, string> => {
    const swatches = extractProductTags(product, 'swatch')
    let style = {}
    if (swatches.length) {
      swatches.forEach(tag => {
        const tagColour = tag.split('_')[1] ? tag.split('_')[1].trim() : tag.split('-')[1].trim();
        const colour = safeJSONParse(colourSwatches)[tagColour];
        style = { '--swatch-color-default': colour  }
      })
    } else {
      style = { '--swatch-color-default': JSON.parse(colourSwatches)['default']  }
    }
    return style
  }

  const roastCount: number = countRoast(product);
  const tasteStr: string = getTasteStrFromTag(product);

  return (
    <div className="cl-product-card glide__slide" data-upsell-item={showSelect ? product.id : ''}>
      <a href={productUrl} title={product.title}>
        {/* Image */}
        <div className="cl-product-card-image relative">
          <img className="cl-product-card-image-img" src={getSizedImageUrl(product.featured_image, '600x600')} alt={product.title} data-lazy-load />
          <ProductCardBox/>
        </div>
      </a>
      {/* Description */}
      <div className="cl-product-card-info flex-one">
        <div className="cl-product-card-info-top flex flex-column flex-one">
          <h2 className="cl-product-card-name heading-5 flex-one"><a href={product.url}>{product.title}</a></h2>
          {roastCount > 0 || tasteStr ? <div className="meta-info flex-one">
            {/* roast before taste, matching the server-rendered card (Liquid
              renders rows in tag order and Roast sorts before Taste) */}
            {roastCount > 0 ? <div className="tastes-like body-small flex align-center gap-small">{roastText} <span className="body-bold-small roast-meta flex align-center gap-xsmall">
              <RoastBeans roastCount={roastCount} />
            </span></div> : null}
            {tasteStr ? <div className="tastes-like body-small">{tasteText} <span className="body-bold-small taste-meta">{tasteStr}</span></div> : null}
          </div> : null}
          <div className="cl-product-card-price flex align-center space-between margin-t-auto">
            <div className="product-price-snippet">
              {assemblePrice(product)}
            </div>
            <div style={swatchHandler()}>
              <button data-quick-add-btn={product.handle} className="quick-add-btn swatch-btn" onClick={() => window['blubolt'].quickadd.open(product.handle, {swatch: swatchHandler()})}>
                {quickAddText}<span className="quick-add-plus">{quickAddPlus}</span>
              </button>
            </div>
          </div>
        </div>
        { showSelect && <div className="cl-product-card-info-bottom"><CartRecommendedSelect product={product} /></div>}
      </div>
    </div>
  )
};

export default ProductCard
